import type { AccountType, TransactionDirection } from "../../types";

export const transactionDirectionChoices: {
  id: TransactionDirection;
  name: string;
}[] = [
  { id: "income", name: "resources.transactions.directions.income" },
  { id: "expense", name: "resources.transactions.directions.expense" },
];

export const accountTypeChoices: { id: AccountType; name: string }[] = [
  { id: "cash", name: "resources.accounts.types.cash" },
  { id: "bank", name: "resources.accounts.types.bank" },
  { id: "card", name: "resources.accounts.types.card" },
  { id: "other", name: "resources.accounts.types.other" },
];
